import { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';

export const CHECKBOX_STYLES: CheckboxDesignTokens = {
  root: {
    width: '1.09375rem',
    height: '1.09375rem',
  },
};
